<template>
<div>
	<h1> AI scientist needed </h1>
	<h4> netikras testas cia</h4>
</div>
</template>

<script>
export default {
	data() {
		return {
			metadata: {
				section: "technology",
				title: "Artificial Inteligence"
			}
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		}
	},
	mounted: function() {
		this.loadToParent();	
	},
}
</script>
